import { workspaceModuleApi } from '../api';
import { useState } from 'react';
import { FetchStatus } from 'types/api';
import { isAxiosError } from 'axios';
import { QAItem } from 'types/api';

export const usePutQa = () => {
  const [status, setPutStatus] = useState<FetchStatus>('idle');
  const [error, setError] = useState<string | null>(null);
  const [response, setResponse] = useState<QAItem | null>(null);

  const putQa = async (
    id: number,
    data: {
      answer: string;
      question: string;
      category: number;
      department: number;
    }
  ) => {
    try {
      setPutStatus('loading');
      const response = await workspaceModuleApi.putQaItem(id, data);
      setResponse(response);
      setPutStatus('success');
    } catch (error) {
      if (isAxiosError(error)) {
        setError(error.response?.data.detail || error.message);
      } else {
        setError('An error occurred');
      }
      setPutStatus('failed');
    }
  };

  return { status, error, response, putQa, setPutStatus };
};
